<!--
 * @Description: 运单列表详情
 * @Author: l_hc
 * @LastEditors: l_hc
 * @Date: 2019-07-19 16:51:17
 * @LastEditTime: 2019-07-24 12:17:58
 -->
<template>
  <div >
  <div class="table-body-item-content"  id="printMe">
    <div class="table-body-item-content-item">
      <el-row>
        <el-col class="marginbottom27 title" :span="6">
          订单信息
        </el-col>
      </el-row>
      <el-row class="marginbottom27">
        <el-col :span="8">
          <el-row>
            <el-col :span="6" style="text-align: right;">订单编号：</el-col>
            <el-col :span="18" style="text-align: left;">{{ tableData.orderNum }}</el-col>
          </el-row>
        </el-col>
        <el-col :span="8">
          <el-row>
            <el-col :span="6" style="text-align: right;">订单状态：</el-col>
            <el-col :span="18" style="text-align: left;" :style="{color: orderStatusLabel}">{{ tableData.orderStatusLabel }}</el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row class="marginbottom27">
        <el-col :span="8">
          <el-row>
            <el-col :span="6" style="text-align: right;">交易日期：</el-col>
            <el-col :span="18" style="text-align: left;">{{ tableData.createDate }}</el-col>
          </el-row>
        </el-col>
        <el-col :span="8">
          <el-row>
            <el-col :span="6" style="text-align: right;">到达日期：</el-col>
            <el-col :span="18" style="text-align: left;">{{ tableData.stopSportDate }}</el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row class="marginbottom27">
        <el-col :span="8">
          <el-row class="startPlaceDtl">
            <el-col :span="6" style="text-align: right;">起运地：</el-col>
            <el-col :span="18" style="text-align: left;">{{ tableData.startPlace }}</el-col>
          </el-row>
        </el-col>
        <el-col :span="16">
          <el-row>
            <el-col :span="3" style="text-align: right;">详细地址：</el-col>
            <el-col :span="21" style="text-align: left;">{{ tableData.startPlaceDtl }}</el-col>
          </el-row>
        </el-col>
      </el-row>

      <el-row class="marginbottom27">
        <el-col :span="8">
          <el-row class="stopPlace">
            <el-col :span="6" style="text-align: right;">目的地：</el-col>
            <el-col :span="18" style="text-align: left;">{{ tableData.stopPlace }}</el-col>
          </el-row>
        </el-col>
        <el-col :span="16">
          <el-row>
            <el-col :span="3" style="text-align: right;">详细地址：</el-col>
            <el-col :span="21" style="text-align: left;">{{ tableData.stopPlaceDtl }}</el-col>
          </el-row>
        </el-col>
      </el-row>

      <el-row class="marginbottom27">
        <el-col :span="8">
          <el-row>
            <el-col :span="6" style="text-align: right;">货物名称：</el-col>
            <el-col :span="18" style="text-align: left;">{{ tableData.goodsTypeLabel }}——{{ tableData.goodsName }}</el-col>
          </el-row>
        </el-col>
        <el-col :span="8">
          <el-row>
            <el-col :span="6" style="text-align: right;">货物重量：</el-col>
            <el-col :span="18" style="text-align: left;">{{ tableData.weight }}吨</el-col>
          </el-row>
        </el-col>
        <el-col :span="8">
          <el-row>
            <el-col :span="6" style="text-align: right;">包装类型：</el-col>
            <el-col :span="18" style="text-align: left;">{{ tableData.packageType }}</el-col>
          </el-row>
        </el-col>
      </el-row>

      <el-row class="marginbottom27">
        <el-col :span="8">
          <el-row>
            <el-col :span="6" style="text-align: right;">运输方式：</el-col>
            <el-col :span="18" style="text-align: left;">{{ tableData.transportMode }}</el-col>
          </el-row>
        </el-col>
        <el-col :span="8">
          <el-row>
            <el-col :span="6" style="text-align: right;">运输价格：</el-col>
            <el-col :span="18" style="text-align: left;">{{ tableData.money }}元</el-col>
          </el-row>
        </el-col>
        <el-col :span="8">
          <el-row>
            <el-col :span="6" style="text-align: right;">付款方式：</el-col>
            <el-col :span="18" style="text-align: left;">{{ tableData.payType }}</el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row class="marginbottom27">
        <el-col :span="24">
          <el-row>
            <el-col :span="2" style="text-align: right;">备注说明：</el-col>
            <el-col :span="18" style="text-align: left;">{{ tableData.remarks }}</el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>

    <!-- 图片展示 -->
    <div class="table-body-item-content-item">
      <el-row>
        <el-col class="marginbottom27 title" :span="6">
          货物图片
        </el-col>
      </el-row>
      <el-row class="center" :span="20">
        <el-row v-viewer class="center img-warp">
          <div v-for="item in tableData.goodsUrls" :key="item" class="img-box">
            <img class="el-image" :src="item | getImg">
          </div>
        </el-row>
      </el-row>
    </div>

    <div class="table-body-item-content-item">
      <el-row>
        <el-col class="marginbottom27 title" :span="6">
          货源方信息
        </el-col>
      </el-row>
      <el-row class="center marginbottom27">
        <el-col :span="8">
          <el-row>
            <el-col :span="6" style="text-align: right;">公司名称：</el-col>
            <el-col :span="18" style="text-align: left;">{{ tableData.goodsCompany }}</el-col>
          </el-row>
        </el-col>
        <el-col :span="8">
          <el-row>
            <el-col :span="6" style="text-align: right;">联系人：</el-col>
            <el-col :span="18" style="text-align: left;">{{ tableData.goodsPerson }}</el-col>
          </el-row>
        </el-col>
        <el-col :span="8">
          <el-row>
            <el-col :span="6" style="text-align: right;">联系电话：</el-col>
            <el-col :span="18" style="text-align: left;">{{ tableData.goodsTel }}</el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row class="center">
        <el-col :span="8">
          <el-row>
            <el-col :span="6" style="text-align: right;">公司地址：</el-col>
            <el-col :span="18" style="text-align: left;">{{ tableData.goodsAddress }}</el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
    <div class="table-body-item-content-item">
      <el-row>
        <el-col class="marginbottom27 title" :span="6">
          承运方信息
        </el-col>
      </el-row>
      <el-row class="center marginbottom27">
        <el-col :span="8">
          <el-row>
            <el-col :span="6" style="text-align: right;">公司名称：</el-col>
            <el-col :span="18" style="text-align: left;">{{ tableData.transportCompany }}</el-col>
          </el-row>
        </el-col>
        <el-col :span="8">
          <el-row>
            <el-col :span="6" style="text-align: right;">联系人：</el-col>
            <el-col :span="18" style="text-align: left;">{{ tableData.transportPerson }}</el-col>
          </el-row>
        </el-col>
        <el-col :span="8">
          <el-row>
            <el-col :span="6" style="text-align: right;">联系电话：</el-col>
            <el-col :span="18" style="text-align: left;">{{ tableData.transportTel }}</el-col>
          </el-row>
        </el-col>
      </el-row>

      <el-row class="center">
        <el-col :span="8">
          <el-row>
            <el-col :span="6" style="text-align: right;">公司地址：</el-col>
            <el-col :span="18" style="text-align: left;">{{ tableData.transportAddress }}</el-col>
          </el-row>
        </el-col>
        <el-col :span="8">
          <el-row>
            <el-col :span="6" style="text-align: right;">运输范围：</el-col>
            <el-col :span="18" style="text-align: left;">{{ tableData.transportScope }}</el-col>
          </el-row>
        </el-col>
        <el-col :span="8">
          <el-row>
            <el-col :span="6" style="text-align: right;">自有车辆：</el-col>
            <el-col :span="18" style="text-align: left;">{{ tableData.transportCarNumLabel }}辆</el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
    <div class="table-body-item-content-item">
      <el-row>
        <el-col class="marginbottom27 title" :span="22">
          运单详情
        </el-col>
        <el-col :span="2" style="text-align: right;">
          <el-button v-if="tableData.transportCount" plain class="details" size="small" @click="tableitem = !tableitem">
            详情
            <i :class="{expand: tableitem}" class="el-icon-d-arrow-right" />
          </el-button>
        </el-col>
      </el-row>
      <div v-if="!tableData.transportCount" class="no-data-info">
        <font>暂无匹配数据</font>
      </div>
      <el-row v-else class="center">
        <el-col :span="8">
          <el-row>
            <el-col :span="6" style="text-align: right;">起运日期：</el-col>
            <el-col :span="18" style="text-align: left;">{{ tableData.startSportDate }}</el-col>
          </el-row>
        </el-col>
        <el-col :span="8">
          <el-row>
            <el-col :span="6" style="text-align: right;">到达日期：</el-col>
            <el-col :span="18" style="text-align: left;">{{ tableData.stopSportDate }}</el-col>
          </el-row>
        </el-col>
        <el-col :span="8">
          <el-row>
            <el-col :span="6" style="text-align: right;">运单个数：</el-col>
            <el-col :span="18" style="text-align: left;">{{ tableData.transportCount }}</el-col>
          </el-row>
        </el-col>
      </el-row>
      <transition name="fade">
        <div v-if="tableitem" class="waybill-box">
          <div v-for="(item, index) in tableData.managerTransportOrders" :key="index" class="waybill-box-item">
            <el-row class="marginbottom27" type="flex" justify="space-between">
              <el-col class="title" style="vertical-align:middle;" :span="18">
                运单{{ index+1 }}：{{ item.startPlace }} <img style="vertical-align:middle;" src="@/assets/img/arrow_half.png">{{ item.stopPlace }}
              </el-col>
              <el-col style="vertical-align:middle;" :span="6">
                <el-col :span="18" style="text-align: left;">{{ item.transportType }}</el-col>
              </el-col>
            </el-row>
            <el-row class="center marginbottom27">
              <el-col :span="8">
                <el-row>
                  <el-col :span="8" style="text-align: right;">运单编号：</el-col>
                  <el-col :span="16" style="text-align: left;">{{ item.tsOrderNum }}</el-col>
                </el-row>
              </el-col>
              <el-col :span="8">
                <el-row>
                  <el-col :span="8" style="text-align: right;">起止日期：</el-col>
                  <el-col :span="16" style="text-align: left;">{{ item.startSportDate }}——{{ item.stopSportDate }}</el-col>
                </el-row>
              </el-col>
              <el-col :span="8">
                <el-row>
                  <el-col :span="8" style="text-align: right;">承运单位：</el-col>
                  <el-col :span="16" style="text-align: left;">{{ tableData.transportCompany }}</el-col>
                </el-row>
              </el-col>
            </el-row>
            <el-row class="center">
              <el-col :span="8">
                <el-row>
                  <el-col :span="8" style="text-align: right;">货物重量：</el-col>
                  <el-col :span="16" style="text-align: left;">{{ item.weight }}吨</el-col>
                </el-row>
              </el-col>
              <el-col :span="8">
                <el-row>
                  <el-col :span="8" style="text-align: right;">联系人：</el-col>
                  <el-col :span="16" style="text-align: left;">{{ item.transportPerson }}</el-col>
                </el-row>
              </el-col>
              <el-col :span="8">
                <el-row>
                  <el-col :span="8" style="text-align: right;">联系电话：</el-col>
                  <el-col :span="16" style="text-align: left;">{{ item. transportTel }}</el-col>
                </el-row>
              </el-col>
            </el-row>
          </div>
        </div>
      </transition>
   </div>
      <!--  打印按钮-->
      <el-row style="margin-top: 20px; text-align: center;">
        <el-col>
          <el-button    v-print="printObj"  class="details hidden" size="small">
            打印
          </el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import print from "vue-print-nb";
export default {
  directives: {
    print,
  },
  name: 'OrderListTableItem',
  props: {
    tableData: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      tableitem: false,
      id: "printMe",//必填，需部分打印输入的ID
      extraCss: "https://cdn.bootcdn.net/ajax/libs/animate.css/4.1.1/animate.compat.css, https://cdn.bootcdn.net/ajax/libs/hover.css/2.3.1/css/hover-min.css",
        extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>',
        previewBeforeOpenCallback () {
          console.log('正在加载预览窗口')
        },
        previewOpenCallback () {
          console.log('已经加载完预览窗口')
        },
        beforeOpenCallback (vue) {
          vue.printLoading = true
          console.log('打开之前')
        },
        openCallback (vue) {
          vue.printLoading = false
          console.log('执行了打印')
        },
        closeCallback () {
          console.log('关闭了打印工具')
        },
        clickMounted (vue) {
          console.log('点击了打印按钮')
          // vue.printSet.popTitle = vue.tableHead // 动态设置页眉
        }

    }
  },
  methods: {
    // 订单状态字体颜色
    orderStatusLabel(status) {
      const obj = {
        '1': '#148B00',
        '2': '#E56100'
      }
      return obj[status]
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../order-list.scss';


  @media print {
    .hidden{
        display: none;
    }
  }

.center{
  text-align: center;
}

// 货物图片
.img-warp{
  display: flex;
  .img-box{
    width: 135px;
    height: 110px;
    margin-right: 14px;
    img{
      width: 100%;
      height: 100%;
    }
  }
}

.table-body{
  &-item{
    box-shadow:0px 2px 6px 0px rgba(0, 0, 0, 0.09);
    border-radius:4px;
    &-head{
      font-size: 14px;
      height: 82px;
      background-color: #fff;
    }
    .address{
      font-size: 18px;
      color: #555555;
      font-weight:bold;
      &-box{
        display: flex;
        justify-content: center;
        align-items: baseline;
        div, div img{
          vertical-align:middle
        }
      }
    }
    &-content{
      background-color: #fafbff;
      &-item{
        font-size: 14px;
        padding: 15px 26px;
        border-top: 1px solid rgba(218,218,218,1);
        .marginbottom27{
          margin-bottom: 27px;
        }
        .title{
          font-size: 16px;
          color: $base-color;
          font-weight: bold;
        }
        .waybill-box-item{
          border: 1px solid #9AB2FF;
          padding: 19px 14px;
          margin-top: 25px;
          .title{
            font-weight:400;
            color: #000;
          }
        }
      }
    }
  }
}
</style>
